import React, { useState, useEffect } from 'react';
import './SuccessNotification.css';

export const SuccessNotification = ({ message, duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible || !message) return null;

  return (
    <div className="success-notification">
      <div className="success-notification-content">
        <span className="success-notification-message">{message}</span>
        <button 
          className="success-notification-close"
          onClick={handleClose}
          aria-label="Закрыть"
        >
          ×
        </button>
      </div>
    </div>
  );
};